import { ColumnData, SlideAction, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutinePreviewColumn } from './routinePreviewColumn';
import { RoutinesBase } from './routines';

export const RoutinePreview = () => {
  const { routineId } = useParams<{ routineId: string }>();
  const navigate = useNavigate();

  if (!routineId) {
    return null;
  }

  const rightColumn: ColumnData = {
    title: 'routine.list.routines',
    mainComponent: <RoutinePreviewColumn />,
    showBackButton: true,
    disableScroll: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate('/new-routines');
    },
  };

  return <RoutinesBase rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};
